import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-navy" data-id="element-166" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-167" data-mp="3b1469ghotr6w">
        <h2 id="testimonios" className="font-display text-[1.6rem] font-extrabold uppercase leading-[1.08] tracking-tight text-white sm:text-4xl" data-id="element-168" data-mp="3ayqbl8qx6gzv">
          Lo que dicen{' '}
          <span className="text-sol" data-id="element-169" data-mp="2x0tfsekaiem9">quienes ya empezaron</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-170" data-mp="2x11pxyp135tr">
          De sentir inseguridad al hablar inglés a comprender mejor las
          situaciones habituales de un viaje.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-171" data-mp="v72jbqmupcne">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-xl border-2 border-sol bg-white p-2.5 text-left text-navy ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-172" data-mp="q8ivtlslzssx" data-mpi={i}>
              <div className="flex items-start justify-between gap-2" data-id="element-173" data-mp="c6ll1rq0c1zz">
                <span className="font-sub text-[11px] font-bold leading-tight text-navy" data-id="element-174" data-mp="c8y304vrmcd1">
                  {t.label}
                </span>
                <div className="flex flex-shrink-0 gap-0.5" aria-label="5 de 5 estrellas" data-id="element-175" data-mp="14w2dgpdmniw7">
                  {Array.from({
                length: 5
              }).map((_, j) => <StarIcon key={j} size={13} className="fill-sol text-sol-dark" data-id="element-176" data-mp="q4jwopcy1kbs" data-mpi={j} />)}
                </div>
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug sm:text-sm" data-id="element-177" data-mp="1nlqs17x68mpe">
                “{t.quote}”
              </blockquote>
              <p className="mt-auto pt-1.5 font-sub text-sm font-bold text-navy" data-id="element-178" data-mp="1xgpmnjb994br">
                {t.author}{' '}
                <span className="font-sans text-xs font-semibold text-navy/70" data-id="element-179" data-mp="1sjpdv0n0tngy">
                  · {t.detail}
                </span>
              </p>
            </Reveal>)}
        </ul>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-180" data-mp="1jhpz6ezhavh6">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
        <p className="mt-2.5 text-xs font-semibold text-white/85" data-id="element-181" data-mp="1el7vzjjsr56y">
          Acceso Inmediato • Garantía de 7 Días
        </p>
      </div>
    </section>;
}